module.exports = __webpack_public_path__ + "img/occidental-resort-2.1666ca02.jpg";